import * as React from 'react';
import { IconProps } from '../types';

const IcCheck = (props: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="0 0 24 24"
    fill="none"
    {...props}
  >
    <circle cx={12.5} cy={12} r={10} fill={props?.fill ?? '#232F3E'} />
    <path
      fill="#fff"
      d="M10.98 15.996a.782.782 0 0 1-.565-.246l-3.02-3.158a.87.87 0 0 1 0-1.184.78.78 0 0 1 1.13 0l2.455 2.568 5.486-5.737a.78.78 0 0 1 1.131 0 .87.87 0 0 1 0 1.183l-6.05 6.328a.782.782 0 0 1-.567.246Z"
    />
  </svg>
);

export default IcCheck;